export default __webpack_public_path__ + "static/gamerize-5-d-c827724c625e965c0a631bef75ec61f7.webp";